var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container"},[_c('v-avatar',{attrs:{"size":_vm.size,"color":"primary"}},[_c('img',{attrs:{"src":_vm.picture}})]),_c('div',{staticClass:"edit-btn"},[_c('v-btn',{attrs:{"icon":"","color":"secondary"},on:{"click":_vm.open}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1)],1),_c('UploadForm',{ref:"form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }